/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

export const jingleCollectionModelSchema = z.object({
    "id": z.string().uuid().describe("Идентификатор подборки"),
"name": z.string().describe("Название подборки"),
"frequency": z.number().int().describe("Частота"),
"startDate": z.string().date().describe("Дата начала"),
"endDate": z.string().date().describe("Дата окончания").nullable().nullish()
    })